// extracted by mini-css-extract-plugin
module.exports = {"manage-cookies":"manage-cookies_manage-cookies__odkfc"};